<div class="message-wrapper">
  <div class="full-message-container" *ngIf="shouldDisplayMessage || message.content.length">
    <app-polaris-icon class="copilot-avatar"></app-polaris-icon>
    <div class="copilot-message-container" [class.expended]="!shouldDisplayThink">
      <div class="copilot-message-title">
        {{ polarisName }}
      </div>
      <div class="copilot-message-content">
        <app-progress-bar *ngIf="!message.content.length && !message.error" [startTimestamp]="message.timestamp"></app-progress-bar>
        <app-markdown [rawMarkdown]="shouldDisplayThink && !message.content.length ? 'Thinking...' : replaceCreativesInMessage(message.content, message.creativesURLs || [])"></app-markdown>
        <div class="try-again-container" *ngIf="message.error">
          <app-button [text]="'Try again'" [class]="'primary'" (click)="tryAgain()">Try again</app-button>
        </div>
      </div>
    </div>
    <app-copilot-insights-message [insights]="message.insights"></app-copilot-insights-message>
    <app-copilot-creatives-message [creativesURLs]="message.creativesURLs"></app-copilot-creatives-message>
    <ng-container *ngFor="let graph of message.graphs">
      <app-copilot-graphs-message [data]="graph"></app-copilot-graphs-message>
    </ng-container>
    <app-copilot-followup-questions-message [followUpQuestions]="message.followUpQuestions | trimSurroundingQuotes" [sendMessage]="sendMessage" [disabled]="!shouldDisplayRetryButton" (onError)="chatNotFound.emit()"></app-copilot-followup-questions-message>
  </div>
  <div class="response-action-buttons-container">
    <app-response-action-buttons
      *ngIf="message.content.length"
      [isCopySucceeded]="isCopySucceeded"
      [shouldDisplayRetryButton]="shouldDisplayRetryButton"
      [userResponse]="message.userResponse"
      (copy)="onCopy()" (share)="onShare()" (goodResponse)="onGoodResponse()" (badResponse)="onBadResponse()" (retry)="onRetry()"
    ></app-response-action-buttons>
  </div>
</div>
